import { useEffect, useState } from 'react';
import { fetchLenderCompanyList } from '../../../store/investor/service';
import { useAppSelector } from '../../../app/hooks';
import { getDealFormConfig } from '../../../store/investor/apiHelpers';
import { VIEW_CONFIGS } from '../../../utils/constants/commonConstants';
import { StatusOption } from '../../Dashboard/DashboardModules/Overview/components/RelatedCompaniesNetwork/types';

const extractStatusOptions = (config: any, field: string): Record<string, StatusOption> => {
    const columns = config?.leadsColumns?.columns || [];
    const col = columns.find((c: any) => c?.field === field);
    return col?.dropdownOptions || {};
};

export function useLenderNetworkDrawer(open: boolean, lenderName: string, pnoId: string) {
    const [companies, setCompanies] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [leadStatusOptions, setLeadStatusOptions] = useState<Record<string, StatusOption>>({});
    const [relationshipStatusOptions, setRelationshipStatusOptions] = useState<Record<string, StatusOption>>({});
    const userData = useAppSelector((state) => state.user.userData);

    useEffect(() => {
        if (!userData?.accountType || !userData?.investorOrgId || !userData?.primaryEmail) return;
        if (Object.keys(leadStatusOptions).length > 0) return;

        getDealFormConfig(
            {
                accountType: userData.accountType,
                investorOrgId: userData.investorOrgId,
                primaryEmail: userData.primaryEmail,
                configName: VIEW_CONFIGS.AICA_DEAL_NAVBAR_VIEW,
            },
            {
                onSuccess: (additionalDetailsConfig) => {
                    setLeadStatusOptions(extractStatusOptions(additionalDetailsConfig, 'companyStatus'));
                    setRelationshipStatusOptions(extractStatusOptions(additionalDetailsConfig, 'customFields.relationshipStatus'));
                },
            },
        );
    }, [userData?.accountType, userData?.investorOrgId, userData?.primaryEmail]);

    useEffect(() => {
        if (open && lenderName && pnoId) {
            loadCompanies();
        }
        if (!open) {
            setCompanies([]);
        }
    }, [open, lenderName, pnoId]);

    const loadCompanies = async () => {
        setIsLoading(true);
        try {
            const response = await fetchLenderCompanyList({ lenderName, pnoId });
            const responseData = response?.data?.responseData;
            if (responseData?.responseCode === 20) {
                setCompanies(response?.data?.data || []);
            }
        } catch (err) {
            console.error('Error fetching lender company list:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return { companies, isLoading, leadStatusOptions, relationshipStatusOptions };
}
